import { Mail, Phone } from "lucide-react";
import { WhatsAppIcon, WHATSAPP_URL } from "./WhatsAppIcon";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
    { id: "servizi", label: "Servizi" },
    { id: "perche-noi", label: "Perché noi" },
    { id: "come-funziona", label: "Come funziona" },
    { id: "contatti", label: "Contatti" },
];

export const Footer = () => (
    <footer className="bg-ink text-cream border-t border-cream/10">
        <div className="mx-auto max-w-7xl px-5 lg:px-10 py-14 lg:py-16">
            <div className="flex flex-col lg:flex-row justify-between gap-12">
                <div className="max-w-sm">
                    <div className="[&_span.text-ink]:text-cream">
                        <Logo dark />
                    </div>
                    <p className="mt-5 text-sm leading-relaxed text-cream/60">
                        Accompagnamento e assistenza non medica. Supporto
                        attivo quotidiano per tutte le età: spese, visite
                        mediche, accompagnamento, passeggiate. Lavoriamo in
                        Emilia-Romagna.
                    </p>
                </div>

                <div className="flex flex-col sm:flex-row gap-10 sm:gap-24">
                    <nav className="flex flex-col gap-3">
                        <p className="mb-1 text-xs font-bold uppercase tracking-[0.2em] text-cream/40">
                            Menu
                        </p>
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`footer-link-${l.id}`}
                                onClick={() => scrollToId(l.id)}
                                className="w-max text-sm font-semibold text-cream/75 hover:text-cream transition-colors duration-300"
                            >
                                {l.label}
                            </button>
                        ))}
                    </nav>
                    <div className="flex flex-col gap-3">
                        <p className="mb-1 text-xs font-bold uppercase tracking-[0.2em] text-cream/40">
                            Contatti
                        </p>
                        <a
                            href="tel:+393522553391"
                            data-testid="footer-phone"
                            className="inline-flex items-center gap-2 text-sm font-semibold text-cream/75 hover:text-cream transition-colors duration-300"
                        >
                            <Phone className="h-4 w-4 text-terracotta" />
                            352 255 3391
                        </a>
                        <a
                            href="mailto:serviziamicielena@gmail.com"
                            data-testid="footer-email"
                            className="inline-flex items-center gap-2 text-sm font-semibold text-cream/75 hover:text-cream transition-colors duration-300 break-all"
                        >
                            <Mail className="h-4 w-4 shrink-0 text-terracotta" />
                            serviziamicielena@gmail.com
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp"
                            className="inline-flex items-center gap-2 text-sm font-semibold text-cream/75 hover:text-cream transition-colors duration-300"
                        >
                            <WhatsAppIcon className="h-4 w-4 shrink-0 text-[#25D366]" />
                            Scrivici su WhatsApp
                        </a>
                    </div>
                </div>
            </div>

            <div className="mt-14 flex flex-col sm:flex-row justify-between gap-3 border-t border-cream/10 pt-7 text-xs text-cream/40">
                <p data-testid="footer-copyright">
                    © {new Date().getFullYear()} ServiziAmici — Accompagnamento e assistenza non medica
                </p>
                <p>Con calma, con cura, in due.</p>
            </div>
        </div>
    </footer>
);

export default Footer;
